<template>
  <div>
    <!-- <AppLoader v-if="isLoading" class="text-center" small /> -->
    <b-overlay :show="isLoading" rounded="sm">
      <b-container fluid>
        <b-navbar toggleable="lg" type="dark" variant="light">
          <b-navbar-brand href="#" class="text-dark">
            <strong>Google Custom Search Engine</strong>
          </b-navbar-brand>

          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

          <b-collapse id="nav-collapse" is-nav>
            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
              <b-nav-form>
                <b-button
                  variant="outline-primary"
                  size="sm"
                  @click="showModal = !showModal"
                  class="mx-2"
                >
                  <font-awesome-icon icon="plus" />
                </b-button>

                <b-button variant="outline-info" size="sm" @click="reloadTable">
                  <font-awesome-icon icon="sync" />
                </b-button>
                <b-form-group
                  label-cols-sm="3"
                  label-align-sm="right"
                  label-size="sm"
                  label-for="filterInput"
                >
                  <b-input-group size="sm">
                    <b-form-input
                      v-model="filter"
                      type="search"
                      id="filterInput"
                      placeholder="Type to Search"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-nav-form>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>

        <b-table
          class="mx-1"
          bordered
          sticky-header="calc(100vh - 200px)"
          ref="table"
          id="my-table"
          :busy.sync="isLoading"
          :items="getGoogleCustomSearchEngineTableData"
          :fields="tableFields"
          :filter="filter"
          :per-page="perPage"
          :current-page="currentPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          responsive="sm"
        >
          <template v-slot:cell(actions)="data">
            <div class="text-nowrap">
              <b-button
                size="sm"
                class="mr-2"
                type="button"
                variant="outline-info"
                @click="onEditGoogleCustomSearchEngine(data)"
              >
                <font-awesome-icon v-b-tooltip.hover title="Edit Field" icon="edit" />
              </b-button>
              <b-button
                size="sm"
                type="button"
                variant="outline-danger"
                @click="onDeleteGoogleCustomSearchEngineModal(data)"
              >
                <font-awesome-icon v-b-tooltip.hover title="Delete Field" icon="trash" />
              </b-button>
            </div>
          </template>
        </b-table>
        <b-row>
          <b-col cols="2">
            <b-form-select v-model="perPage" id="perPageSelect" size="sm" :options="pageOptions"></b-form-select>
          </b-col>
          <b-col>
            <b-pagination
              class="float-right"
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              first-text="First"
              prev-text="Prev"
              next-text="Next"
              last-text="Last"
              aria-controls="my-table"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-container>
    </b-overlay>
    <b-modal
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      size="lg"
      :title="editGoogleCustomSearchEngine ? 'Update Google Custom Search Engine' : 'Create Google Custom Search Engine'"
      v-model="showModal"
    >
      <div>
        <div v-if="!submiting && !responseSuccess">
          <b-row>
            <b-col cols="6">
              <b-form-group>
                <label>
                  Title :
                  <span class="required-span">*</span>
                </label>
                <b-form-input
                  v-model="$v.form.titleInput.$model"
                  :state="$v.form.titleInput.$dirty ? !$v.form.titleInput.$error : null"
                  placeholder="Enter Title"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label="Description:">
                <b-form-textarea
                  v-model="form.descriptionInput"
                  rows="2"
                  max-rows="2"
                  placeholder="Enter Description"
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-group>
                <label>
                  Google Search Engine Api Key :
                  <span class="required-span">*</span>
                </label>
                <b-form-input
                  v-model="$v.form.googleSearchEngineApiKey.$model"
                  :state="$v.form.googleSearchEngineApiKey.$dirty ? !$v.form.googleSearchEngineApiKey.$error : null"
                  placeholder="Enter Google Search Engine Api Key"
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group>
                <label>
                  Google Search Engine Secret Key :
                  <span class="required-span">*</span>
                </label>
                <b-form-input
                  v-model="$v.form.googleSearchEngineSecretKey.$model"
                  :state="$v.form.googleSearchEngineSecretKey.$dirty ? !$v.form.googleSearchEngineSecretKey.$error : null"
                  placeholder="Enter Google Search Engine Secret Key"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <div v-else-if="submiting && !responseSuccess">
          <p>{{editGoogleCustomSearchEngine ? 'Your Google Custom Search Engine is being Updating......' : 'Your Google Custom Search Engine is being Creating......'}}</p>
          <b-spinner type="grow" label="Loading..."></b-spinner>
        </div>
        <div v-else>
          <p class="my-2 text-center">
            {{ editGoogleCustomSearchEngine ? 'Your Google Custom Search Engine has been updated successfully.' : 'Your Google Custom Search Engine has been added successfully.' }}
            <br />
          </p>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button v-if="!submiting" variant="outline-danger" @click="resetModal">Close</b-button>
        <b-button
          v-if="!submiting && !responseSuccess"
          variant="outline-success"
          @click="checkValidation()"
        >{{ editGoogleCustomSearchEngine ? 'Update' : 'Save' }}</b-button>
      </template>
    </b-modal>
    <b-overlay :show="showDeleteGoogleCustomSearchEngineModal" no-wrap>
      <template v-slot:overlay>
        <div v-if="processing" class="text-center p-4 bg-primary text-light rounded">
          <font-awesome-icon size="lg" icon="cloud-upload-alt" />
          <div class="mb-3">Deleting...</div>
          <b-progress
            min="1"
            max="20"
            :value="counter"
            variant="success"
            height="3px"
            class="mx-n4 rounded-0"
          ></b-progress>
        </div>
        <div
          v-else
          ref="dialog"
          tabindex="-1"
          role="dialog"
          aria-modal="false"
          aria-labelledby="form-confirm-label"
          class="text-center p-3"
        >
          <p>
            <strong id="form-confirm-label">Are you sure?</strong>
          </p>
          <div class="d-flex">
            <b-button variant="outline-success" class="mr-3" @click="resetDeleteModal">Cancel</b-button>
            <b-button variant="outline-danger" @click="deleteGoogleCustomSearchEngineCall">Yes</b-button>
          </div>
        </div>
      </template>
    </b-overlay>
    <!-- <b-modal
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      title="Delete Field"
      v-model="showDeleteGoogleCustomSearchEngineModal"
    >
      <div>
        <div v-if="!submiting && !responseSuccess">
          <p>Are you sure you want to delete this Google Custom Search Engine ?</p>
        </div>
        <div v-else-if="submiting && !responseSuccess">
          <p>Google Custom Search Engine is being deleting......</p>
          <b-spinner type="grow" label="Loading..."></b-spinner>
        </div>
        <div v-else>
          <p class="my-2 text-center">
            Google Custom Search Engine has been deleted successfully.
            <br />
          </p>
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button v-if="!submiting" @click="resetDeleteModal">Close</b-button>
        <b-button
          v-if="!submiting && !responseSuccess"
          variant="danger"
          @click="deleteGoogleCustomSearchEngineCall"
        >
          <font-awesome-icon
            v-b-tooltip.hover
            title="Delete Field"
            class="mr-1 text-light"
            icon="trash"
          />Yes
        </b-button>
      </template>
    </b-modal>-->
  </div>
</template>
<script>
import { HTTP } from "../../utils/HTTP";
import AppLoader from "../../components/Loader/Loader";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
export default {
  name: "ClientProfileGoogleCustomSearchEngine",
  mixins: [validationMixin],
  components: {
    AppLoader
  },
  data() {
    return {
      editGoogleCustomSearchEngine: false,
      submiting: false,
      responseSuccess: false,
      form: {
        titleInput: null,
        descriptionInput: null,
        googleSearchEngineApiKey: null,
        googleSearchEngineSecretKey: null
      },
      isLoading: false,
      showModal: false,
      tableFields: [
        { key: "created_at", label: "Age", sortable: true },
        { key: "title", label: "Title", sortable: true },
        { key: "description", label: "Description", sortable: true },
        {
          key: "google_search_engine_api_key",
          label: "Google Search Engine Api Key",
          sortable: true
        },
        {
          key: "google_search_engine_secret_key",
          label: "Google Search Engine Secret Key",
          sortable: true
        },
        { key: "actions", label: "Actions", sortable: false }
      ],
      filter: null,
      perPage: 10,
      totalRows: 0,
      currentPage: 1,
      sortBy: "id",
      sortDesc: true,
      pageOptions: [5, 10, 25, 50, 75, 100],
      showDeleteGoogleCustomSearchEngineModal: false,
      googleCustomSearchEngineId: null,
      processing: false,
      counter: 1,
      interval: null
    };
  },
  mounted() {},
  computed: {
    rows() {
      return this.totalRows;
    }
  },
  validations: {
    form: {
      titleInput: { required },
      googleSearchEngineApiKey: { required },
      googleSearchEngineSecretKey: { required }
    }
  },
  beforeDestroy() {
    this.clearInterval();
  },
  methods: {
    clearInterval() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
    },
    reloadTable() {
      this.$root.$emit("bv::refresh::table", "my-table");
    },
    async getGoogleCustomSearchEngineTableData() {
      let formData = {
        filter: this.filter,
        sort: this.sortBy + "|" + (this.sortDesc == true ? "desc" : "asc"),
        per_page: this.perPage,
        page: this.currentPage
      };

      let token = "Bearer " + localStorage.getItem("accessToken");
      this.isLoading = true;
      let result = HTTP(
        "post",
        "v1/google-custom-search-engine/get-custom-search-engine-list",
        formData,
        {
          Authorization: token
        }
      );

      return result
        .then(response => {
          const items = response.data.data;
          this.isLoading = false;
          this.totalRows = response.data.total;
          return items;
        })
        .catch(error => {
          this.isLoading = false;
          return [];
        });
    },
    resetForm() {
      this.form = {
        titleInput: null,
        descriptionInput: null,
        googleSearchEngineApiKey: null,
        googleSearchEngineSecretKey: null
      };
    },
    resetModal() {
      this.resetForm();
      this.editGoogleCustomSearchEngine = false;
      this.responseSuccess = false;
      this.submiting = false;
      this.isLoading = false;
      this.showModal = false;
    },
    checkValidation() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      } else if (this.editGoogleCustomSearchEngine) {
        this.updateGoogleCustomSearchEngine().then(this.reloadTable);
      } else {
        this.saveGoogleCustomSearchEngine().then(this.reloadTable);
      }
    },
    async saveGoogleCustomSearchEngine() {
      let formData = {
        title: this.form.titleInput,
        description: this.form.descriptionInput,
        google_search_engine_api_key: this.form.googleSearchEngineApiKey,
        google_search_engine_secret_key: this.form.googleSearchEngineSecretKey
      };
      try {
        let token = "Bearer " + localStorage.getItem("accessToken");
        this.submiting = true;
        this.isLoading = true;
        let result = await HTTP(
          "post",
          "v1/google-custom-search-engine/create-custom-search-engine",
          formData,
          {
            Authorization: token
          }
        );
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
      } catch (err) {
        // console.log("------------erroror", err);
      }
    },
    onEditGoogleCustomSearchEngine(data) {
      // console.log(data.item);
      this.editGoogleCustomSearchEngine = true;
      this.googleCustomSearchEngineId = data.item.id;
      this.form = {
        titleInput: data.item.title,
        descriptionInput: data.item.description,
        googleSearchEngineApiKey: data.item.google_search_engine_api_key,
        googleSearchEngineSecretKey: data.item.google_search_engine_secret_key
      };
      this.showModal = true;
    },
    async updateGoogleCustomSearchEngine() {
      let formData = {
        google_custom_search_engine_id: this.googleCustomSearchEngineId,
        title: this.form.titleInput,
        description: this.form.descriptionInput,
        google_search_engine_api_key: this.form.googleSearchEngineApiKey,
        google_search_engine_secret_key: this.form.googleSearchEngineSecretKey
      };
      try {
        let token = "Bearer " + localStorage.getItem("accessToken");
        this.submiting = true;
        this.isLoading = true;
        let result = await HTTP(
          "post",
          "v1/google-custom-search-engine/update-custom-search-engine",
          formData,
          {
            Authorization: token
          }
        );
        this.googleCustomSearchEngineId = null;
        this.submiting = false;
        this.isLoading = false;
        this.responseSuccess = true;
      } catch (err) {
        // console.log("------------erroror", err);
      }
    },
    onDeleteGoogleCustomSearchEngineModal(data) {
      this.googleCustomSearchEngineId = data.item.id;
      this.processing = false;
      this.showDeleteGoogleCustomSearchEngineModal = true;
    },
    deleteGoogleCustomSearchEngineCall() {
      this.counter = 1;
      this.processing = true;
      this.deleteGoogleCustomSearchEngine().then(this.reloadTable);
      this.clearInterval();
      this.interval = setInterval(() => {
        if (this.counter < 20) {
          this.counter = this.counter + 1;
        } else {
          this.clearInterval();
          this.$nextTick(() => {
            this.showDeleteGoogleCustomSearchEngineModal = this.processing = false;
          });
        }
      }, 350);
    },
    async deleteGoogleCustomSearchEngine() {
      try {
        let token = "Bearer " + localStorage.getItem("accessToken");
        let result = await HTTP(
          "get",
          "v1/google-custom-search-engine/deletegooglecustomsearchengine/" +
            this.googleCustomSearchEngineId,
          null,
          {
            Authorization: token
          }
        );
        this.googleCustomSearchEngineId = null;
      } catch (error) {
        this.isLoading = false;
      }
    },
    resetDeleteModal() {
      this.showDeleteGoogleCustomSearchEngineModal = false;
    }
  }
};
</script>